import { Text } from '@backstage/ui';

type FieldHintProps = {
  children?: string;
  error?: boolean;
};

/** Helper text below a BUI field. BUI `description` renders above the input. */
export const FieldHint = ({ children, error = false }: FieldHintProps) => {
  if (!children) {
    return null;
  }

  return (
    <Text
      variant="body-small"
      color={error ? 'danger' : 'secondary'}
      role={error ? 'alert' : undefined}
    >
      {children}
    </Text>
  );
};
